import React from "react";
import GapCard from "../components/GapCard";
import { useI18n } from "../i18n/I18nProvider";

export default function KnowledgeGap() {
  const { t } = useI18n();

  return (
    <section className="py-20 sm:py-24 lg:py-12 px-4 sm:px-6 bg-[#fdf7ef]">
      <div className="max-w-6xl mx-auto text-center">
        {/* =================== HEADING =================== */}
        <h2
          className="font-playfair italic text-[32px] sm:text-[40px] md:text-[56px] lg:text-[72px] xl:text-[80px] font-semibold leading-tight"
          style={{ color: "#033049" }}
        >
          {t("knowledgeGap.title.prefix")}{" "}
          <span style={{ color: "#F1AF38" }}>
            {t("knowledgeGap.title.highlight1")}
          </span>{" "}
          {t("knowledgeGap.title.afterHighlight1")}
          <br />
          {t("knowledgeGap.title.line2Prefix")}{" "}
          <span style={{ color: "#F1AF38" }}>
            {t("knowledgeGap.title.highlight2")}
          </span>
        </h2>

        {/* =================== PARAGRAPH =================== */}
        <p className="mt-6 sm:mt-8 text-base md:text-lg lg:text-xl text-[#033049] max-w-4xl mx-auto leading-[1.6]">
          {t("knowledgeGap.description")}
        </p>

        {/* =================== CARDS GRID =================== */}
        <div className="mt-14 sm:mt-16 lg:mt-20 grid grid-cols-1 md:grid-cols-2 gap-x-5 gap-y-5 auto-rows-fr">
          {/* CARD 1: Information Overload (Top Left) */}
          <div className="h-full">
            <GapCard
              bg="bg-[#e0e9eb]"
              rounded="rounded-[24px]"
              title={t("knowledgeGap.cards.informationOverload.title")}
              icon={
                <svg
                  width="106"
                  height="150"
                  viewBox="0 0 106 150"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M24.5136 149.247L21.0459 148.84C16.4362 148.3 11.7786 148.335 7.17775 148.946L3.7164 149.406C2.26901 149.597 0.980626 148.478 0.969269 147.017L0.00013702 20.6134C-0.0187913 18.1956 1.92578 16.221 4.34229 16.2021L21.8459 16.0683C24.2624 16.0493 26.2373 17.9949 26.255 20.4127L27.2241 146.816C27.2355 148.276 25.9635 149.417 24.5136 149.247Z"
                    fill="#033049"
                  />
                  <path
                    d="M20.2572 134.004C20.2837 137.463 17.5025 140.288 14.0462 140.314C10.5886 140.341 7.76454 137.558 7.73804 134.1C7.71154 130.641 10.4927 127.816 13.9491 127.789C17.4066 127.762 20.2307 130.545 20.2572 134.004Z"
                    fill="#8ECAEC"
                  />
                  <path
                    d="M14.7377 120.656L11.959 120.678C10.9142 120.685 10.0599 119.845 10.0523 118.798L9.34693 26.814C9.33936 25.7686 10.1798 24.9139 11.2259 24.9063L14.0046 24.8848C15.0494 24.8772 15.9037 25.7181 15.9113 26.7635L16.6167 118.747C16.623 119.794 15.7826 120.648 14.7377 120.656Z"
                    fill="#8ECAEC"
                  />
                  <path
                    d="M52.5755 28.705L53.4853 147.532C53.4954 148.911 52.2348 149.99 50.7685 149.817L47.3084 149.452C42.6873 148.932 38.0486 148.967 33.4364 149.558L29.9826 149.976C28.5176 150.173 27.2406 149.113 27.2305 147.734L26.3206 28.907C26.303 26.6433 28.2576 24.776 30.6653 24.757L48.169 24.6232C50.5741 24.603 52.5578 26.4413 52.5755 28.705Z"
                    fill="#F1AF38"
                  />
                  <path
                    d="M53.3222 124.977L27.0661 125.179L27.1047 130.2L53.3608 129.998L53.3222 124.977Z"
                    fill="#8ECAEC"
                  />
                  <path
                    d="M53.3919 134.032L27.1358 134.234L27.1744 139.256L53.4305 139.053L53.3919 134.032Z"
                    fill="#8ECAEC"
                  />
                  <path
                    d="M78.9198 40.1475L79.7426 147.55C79.7527 148.796 78.4908 149.773 77.0232 149.616L73.5631 149.289C68.9433 148.822 64.3046 148.858 59.6924 149.395L56.2387 149.775C54.7736 149.954 53.4978 148.996 53.4877 147.75L52.665 40.3482C52.6498 38.3016 54.6058 36.6136 57.0122 36.5947L74.5158 36.4609C76.9223 36.4419 78.9047 38.1009 78.9198 40.1475Z"
                    fill="#033049"
                  />
                  <path
                    d="M105.281 53.716L106 147.605C106.009 148.7 104.746 149.563 103.279 149.422L99.8206 149.142C98.6597 149.041 97.5 148.962 96.3403 148.927C93.9983 148.836 91.6347 148.854 89.2952 148.981C88.1797 149.033 87.0642 149.129 85.9499 149.248L82.4949 149.581C81.0299 149.745 79.7541 148.902 79.7465 147.807L79.0272 53.918C79.0134 52.1227 80.9718 50.6405 83.3782 50.6228L100.882 50.489C103.287 50.47 105.267 51.9207 105.281 53.716Z"
                    fill="#F1AF38"
                  />
                  <path
                    d="M67.4772 50.7443L64.8272 50.7648C64.2749 50.769 63.8306 51.2202 63.8349 51.7725L64.4983 137.97C64.5025 138.522 64.9537 138.967 65.5059 138.962L68.156 138.942C68.7083 138.938 69.1526 138.486 69.1483 137.934L68.4849 51.7366C68.4807 51.1844 68.0295 50.7401 67.4772 50.7443Z"
                    fill="#8ECAEC"
                  />
                  <path
                    d="M95.5843 50.5283L96.3389 148.927C93.9968 148.836 91.6333 148.854 89.2938 148.982L88.5392 50.5826L95.5843 50.5283Z"
                    fill="#8ECAEC"
                  />
                  <path
                    d="M16.9158 4.53127C14.8425 5.39864 13.1692 7.02985 12.243 9.06255C11.3168 7.03111 9.6435 5.39864 7.57022 4.53127C9.6435 3.67274 11.3168 2.04027 12.243 0C13.1692 2.04027 14.8437 3.67274 16.9158 4.53127Z"
                    fill="#F1AF38"
                  />
                  <path
                    d="M60.4092 9.0613C58.3359 9.92867 56.6627 11.5599 55.7365 13.5926C54.8102 11.5611 53.137 9.92867 51.0637 9.0613C53.137 8.20277 54.8102 6.5703 55.7365 4.53003C56.6627 6.5703 58.3359 8.20277 60.4092 9.0613Z"
                    fill="#033049"
                  />
                  <path
                    d="M105.684 36.4612C103.611 37.3286 101.938 38.9598 101.012 40.9925C100.085 38.961 98.4122 37.3286 96.3389 36.4612C98.4122 35.6027 100.085 33.9702 101.012 31.9299C101.938 33.9702 103.611 35.6027 105.684 36.4612Z"
                    fill="#F1AF38"
                  />
                </svg>
              }
            >
              {t("knowledgeGap.cards.informationOverload.description")}
            </GapCard>
          </div>

          {/* CARD 2: English-Centric Knowledge (Top Right) */}
          <div className="h-full md:mt-8 lg:pt-16">
            <GapCard
              bg="bg-[#f6e6cb]"
              rounded="rounded-[24px]"
              title={t("knowledgeGap.cards.englishCentric.title")}
              icon={
                <svg
                  width="228"
                  height="100"
                  viewBox="0 0 228 100"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M198.136 84.4675C198.109 87.6556 197.898 90.7903 197.503 93.8997C197.319 95.3106 197.108 96.7481 196.844 98.1322L187.935 97.975L129.076 96.9039H129.024C128.522 96.852 128.18 96.4336 128.18 95.9366C128.259 93.1936 128.048 98.2094 127.653 95.4663C127.415 94.1074 127.152 92.7485 126.783 91.4163C126.388 90.1093 126.046 88.7771 125.439 87.5755C124.938 86.3219 124.227 85.1974 123.489 84.1263L122.225 82.6635C121.961 82.4024 121.698 82.1933 121.434 81.9589C121.355 81.9069 121.276 81.855 121.223 81.8016C121.065 81.6977 120.908 81.5657 120.776 81.4352C120.328 80.9916 119.695 80.8611 119.168 80.5213C118.878 80.3908 118.642 80.2335 118.326 80.1297L117.429 79.9205C117.377 79.8938 117.325 79.8938 117.271 79.8938C116.506 79.6327 115.689 79.5541 114.872 79.5541L114.608 79.5021H113.369L113.106 79.5541C112.288 79.5541 111.471 79.6327 110.733 79.8938C110.654 79.8938 110.602 79.8938 110.575 79.9205L109.653 80.1297C109.362 80.2335 109.099 80.3908 108.809 80.5213C108.282 80.8611 107.649 80.9916 107.201 81.4352C107.097 81.5657 106.938 81.6963 106.779 81.8016C106.7 81.8535 106.621 81.9054 106.568 81.9589C106.278 82.1933 106.014 82.4024 105.778 82.6635L104.486 84.1263C103.776 85.1974 103.036 86.3204 102.536 87.5755C101.957 88.7771 101.587 90.1093 101.192 91.4163C100.85 92.7485 100.559 94.1074 100.348 95.4663C99.9261 98.2094 99.7151 93.1936 99.7944 95.9633C99.8214 96.4336 99.4517 96.852 98.9773 96.9039H98.8979L75.7554 97.3223L31.1569 98.1322C30.9204 96.7214 30.7094 95.3373 30.5238 93.8997C30.0225 90.1375 29.8129 86.27 29.8653 82.352C30.1287 60.3009 39.0382 40.34 53.3506 25.6042C61.7064 16.9819 71.9329 10.1369 83.3733 5.69526C84.2952 5.33031 85.2441 4.99058 86.193 4.67607C94.5218 1.77578 103.431 0.15577 112.709 0H115.081C137.511 0.287804 157.782 9.24831 172.673 23.6192C188.647 39.0316 198.452 60.6391 198.136 84.4675Z"
                    fill="#8ECAEC"
                  />
                  <path
                    d="M159.409 45.9432C173.075 50.06 164.098 12.7523 156.924 34.207C155.661 37.9856 154.213 44.3766 159.409 45.9432Z"
                    fill="#033049"
                  />
                  <path
                    d="M65.9586 38.3092C65.9586 38.3092 62.4534 42.3711 65.8299 48.2044C69.2063 54.0376 73.7037 53.9219 72.9673 48.2948C72.2325 42.6663 67.5345 34.0426 65.9586 38.3092Z"
                    fill="#033049"
                  />
                  <path
                    d="M75.7541 97.3226L31.1556 98.1326C30.9192 96.7217 30.7081 95.3376 30.5225 93.9001C30.0212 90.1378 29.8116 86.2703 29.864 82.3523C30.1274 60.3012 39.037 40.3403 53.3493 25.6045C61.8099 29.7584 59.4646 51.6537 64.6041 57.4276C66.6605 59.7271 74.5403 62.9404 72.9075 66.7545C71.1414 70.9084 65.2102 73.2346 62.8919 77.4403C61.31 80.3406 60.8355 84.0509 62.6016 86.8459C65.0785 90.7906 70.7463 91.4181 74.015 94.6849C74.1736 94.8154 74.3053 94.946 74.437 95.1032C74.9638 95.6758 75.4114 96.4339 75.7541 97.3226Z"
                    fill="#033049"
                  />
                  <path
                    d="M198.136 84.4674C198.109 87.6555 197.898 90.7902 197.503 93.8997C197.319 95.3105 197.108 96.7481 196.845 98.1322L187.935 97.975C186.432 96.7466 184.93 95.5449 183.717 94.1341C182.689 92.9844 181.872 91.6522 181.45 90.0589C180.817 87.7594 181.212 85.2522 180.58 82.9528C179.552 79.2692 176.1 76.7872 172.647 75.1405C169.167 73.5205 165.372 72.4227 162.314 70.098C159.256 67.7733 157.095 63.6966 158.466 60.1436C159.758 56.8249 163.474 55.2064 165.821 52.5405C170.96 46.6613 168.615 31.2207 172.674 23.6177C188.647 39.0315 198.452 60.639 198.136 84.4674Z"
                    fill="#033049"
                  />
                  <path
                    d="M99.7168 86.9392C99.7168 86.9392 68.4744 83.4885 13.1795 79.9785L5.8938 92.7561C5.8938 92.7561 40.8793 91.7711 99.7153 95.5259V86.9392H99.7168Z"
                    fill="#033049"
                  />
                  <path
                    d="M102.592 85.6444C102.592 85.6444 72.5647 78.8839 20.1163 68.9458L13.8798 77.307C13.8798 77.307 47.3777 80.4164 103.183 91.0118L102.592 85.6444Z"
                    fill="#033049"
                  />
                  <path
                    d="M127.535 86.9392C127.535 86.9392 158.777 83.4885 214.072 79.9785L221.358 92.7561C221.358 92.7561 186.372 91.7711 127.536 95.5259L127.535 86.9392Z"
                    fill="#033049"
                  />
                  <path
                    d="M124.658 85.6444C124.658 85.6444 154.685 78.8839 207.134 68.9458L213.37 77.307C213.37 77.307 179.872 80.4164 124.067 91.0118L124.658 85.6444Z"
                    fill="#033049"
                  />
                  <path
                    d="M228 96.0807C228 98.2496 226.234 100 224.046 100H125.862C124.781 100 123.753 99.5818 123.015 98.7985C122.277 98.0404 121.882 97.0227 121.908 95.9501C121.96 94.3049 121.538 89.0532 118.85 86.2835C117.663 85.0551 116.056 84.4024 113.999 84.3237C111.943 84.4024 110.335 85.0551 109.149 86.2835C106.461 89.0532 106.039 94.3049 106.091 95.9501C106.118 97.0212 105.721 98.0404 104.983 98.7985C104.246 99.5818 103.217 100 102.137 100H3.95413C1.76604 100 0 98.2496 0 96.0807C0 93.9118 1.76604 92.1612 3.95413 92.1612H98.4222C98.8697 88.8693 100.109 84.2703 103.457 80.8478C104.985 79.2545 106.83 78.1048 108.939 77.3986C110.494 76.8245 112.181 76.5367 113.999 76.51C115.818 76.5367 117.504 76.823 119.059 77.3986C121.168 78.1048 123.014 79.2545 124.542 80.8478C127.89 84.2703 129.127 88.8693 129.576 92.1612H224.044C226.234 92.1612 228 93.9118 228 96.0807Z"
                    fill="#F1AF38"
                  />
                  <path
                    d="M45.0834 44.2628C42.9656 45.1396 41.2565 46.7922 40.3106 48.8484C39.3647 46.7922 37.6555 45.1411 35.5378 44.2628C37.6555 43.3935 39.3647 41.7423 40.3106 39.6772C41.2565 41.7423 42.9656 43.3935 45.0834 44.2628Z"
                    fill="#F1AF38"
                  />
                  <path
                    d="M192.464 44.2628C190.346 45.1396 188.637 46.7922 187.691 48.8484C186.745 46.7922 185.036 45.1411 182.918 44.2628C185.036 43.3935 186.745 41.7423 187.691 39.6772C188.635 41.7423 190.346 43.3935 192.464 44.2628Z"
                    fill="#F1AF38"
                  />
                  <path
                    d="M118.774 57.2272C116.656 58.1054 114.945 59.7566 114.001 61.8128C113.055 59.7566 111.346 58.1054 109.228 57.2272C111.346 56.3578 113.055 54.7067 114.001 52.6416C114.945 54.7067 116.656 56.3578 118.774 57.2272Z"
                    fill="#F1AF38"
                  />
                </svg>
              }
            >
              {t("knowledgeGap.cards.englishCentric.description")}
            </GapCard>
          </div>

          {/* CARD 3: Time Constraints (Bottom Left) */}
          <div className="h-full">
            <GapCard
              bg="bg-[#f6e6cb]"
              rounded="rounded-[24px]"
              title={t("knowledgeGap.cards.timeConstraints.title")}
              icon={
                <svg
                  width="142"
                  height="150"
                  viewBox="0 0 142 150"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M105.066 5.75273L105.043 8.26625L104.973 16.5567H24.2322C19.6811 16.5567 15.9759 12.8456 15.9759 8.29049V8.26625C15.9759 6.76356 16.3746 5.35351 17.1023 4.1331C17.6178 3.2178 18.2984 2.41944 19.1201 1.785C20.527 0.657271 22.3098 0 24.2337 0H99.3668C100.986 0 102.463 0.681508 103.495 1.785C104.129 2.44226 104.597 3.24061 104.832 4.1331C104.994 4.64921 105.066 5.18815 105.066 5.75273Z"
                    fill="#8ECAEC"
                  />
                  <path
                    d="M114.495 1.78345V96.5701H15.9744V8.26469C15.9744 6.762 16.3732 5.35199 17.1008 4.13159C17.6163 3.21629 18.297 2.41789 19.1186 1.78345H114.495Z"
                    fill="#033049"
                  />
                  <path
                    d="M120.5 4.13159V98.9182H15.9744V8.2647C15.9744 6.762 16.3732 5.352 17.1008 4.13159H120.5Z"
                    fill="#8ECAEC"
                  />
                  <path
                    d="M128.569 15.1238V143.12C128.569 146.923 125.496 150 121.697 150H22.8467C19.046 150 15.973 146.923 15.973 143.12V8.2662C15.973 6.76351 16.3717 5.35346 17.0994 4.13306C17.2162 4.3683 17.3813 4.62638 17.5451 4.83738C17.7558 5.11967 17.9908 5.40053 18.2258 5.66001C18.7413 6.20035 19.3052 6.66939 19.9375 7.04577C20.5711 7.44497 21.2504 7.75008 21.9553 7.93828C22.2372 8.03237 22.5419 8.10225 22.8467 8.1493C23.0104 8.17211 23.1514 8.19636 23.3394 8.21917C23.6213 8.24198 23.9261 8.2662 24.2308 8.2662H121.697C122.564 8.2662 123.408 8.43017 124.183 8.73528C126.763 9.72187 128.569 12.2111 128.569 15.1238Z"
                    fill="#033049"
                  />
                  <path
                    d="M72.2723 103.781C87.0089 103.781 98.9553 91.8207 98.9553 77.0665C98.9553 62.3122 87.0089 50.3516 72.2723 50.3516C57.5358 50.3516 45.5894 62.3122 45.5894 77.0665C45.5894 91.8207 57.5358 103.781 72.2723 103.781Z"
                    fill="#F1AF38"
                  />
                  <path
                    d="M63.7682 91.0593L64.0516 63.0713L88.1186 77.3112L63.7682 91.0593Z"
                    fill="#033049"
                  />
                  <path
                    d="M142 31.1447C139.985 31.9872 138.359 33.5755 137.459 35.5515C136.559 33.5755 134.931 31.9887 132.918 31.1447C134.933 30.3092 136.559 28.7224 137.459 26.7378C138.359 28.7224 139.985 30.3106 142 31.1447Z"
                    fill="#F1AF38"
                  />
                  <path
                    d="M142 123.942C139.985 124.785 138.359 126.373 137.459 128.349C136.559 126.373 134.931 124.786 132.918 123.942C134.933 123.107 136.559 121.52 137.459 119.535C138.359 121.52 139.985 123.107 142 123.942Z"
                    fill="#F1AF38"
                  />
                  <path
                    d="M9.0837 91.0597C7.06874 91.9037 5.44253 93.4905 4.54113 95.4666C3.64116 93.4905 2.01496 91.9037 0 91.0597C2.01496 90.2242 3.64116 88.6374 4.54113 86.6528C5.4411 88.6374 7.06874 90.2242 9.0837 91.0597Z"
                    fill="#F1AF38"
                  />
                </svg>
              }
            >
              {t("knowledgeGap.cards.timeConstraints.description")}
            </GapCard>
          </div>

          {/* CARD 4: Curation Gap (Bottom Right) */}
          <div className="h-full md:mt-8 lg:mt-10">
            <GapCard
              bg="bg-[#e0e9eb]"
              rounded="rounded-[24px]"
              title={t("knowledgeGap.cards.curationGap.title")}
              icon={
                <svg
                  width="178"
                  height="150"
                  viewBox="0 0 178 150"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M168.859 121.42H8.36951V124.769H168.859V121.42Z"
                    fill="#8ECAEC"
                  />
                  <path
                    d="M168.859 127.5H8.36951V130.85H168.859V127.5Z"
                    fill="#8ECAEC"
                  />
                  <path
                    d="M168.859 133.58H8.36951V136.93H168.859V133.58Z"
                    fill="#8ECAEC"
                  />
                  <path
                    d="M156.635 150H5.0225C2.24817 150 0 147.751 0 144.974C0 142.198 2.24817 139.948 5.0225 139.948H156.635C162.57 139.948 167.398 135.115 167.398 129.174C167.398 123.235 162.568 118.401 156.635 118.401H5.0225C2.24817 118.401 0 116.151 0 113.375C0 110.598 2.24817 108.349 5.0225 108.349H156.635C168.107 108.349 177.441 117.689 177.441 129.172C177.441 140.654 168.107 150 156.635 150Z"
                    fill="#033049"
                  />
                  <path
                    d="M169.072 79.7712H8.58228V83.1207H169.072V79.7712Z"
                    fill="#8ECAEC"
                  />
                  <path
                    d="M169.072 85.8518H8.58228V89.2013H169.072V85.8518Z"
                    fill="#8ECAEC"
                  />
                  <path
                    d="M169.072 91.9314H8.58228V95.2809H169.072V91.9314Z"
                    fill="#8ECAEC"
                  />
                  <path
                    d="M20.8065 108.35H172.419C175.193 108.35 177.441 106.1 177.441 103.324C177.441 100.548 175.193 98.2981 172.419 98.2981H20.8065C14.8716 98.2981 10.0432 93.4644 10.0432 87.5235C10.0432 81.5825 14.8716 76.7506 20.8065 76.7506H172.419C175.193 76.7506 177.441 74.5008 177.441 71.7245C177.441 68.9482 175.193 66.6985 172.419 66.6985H20.8065C9.33417 66.6985 2.79587e-07 76.0393 2.79587e-07 87.5216C-0.00186544 99.0076 9.33417 108.35 20.8065 108.35Z"
                    fill="#033049"
                  />
                  <path
                    d="M10.8566 49.2271C10.364 49.2271 9.96472 48.8275 9.96472 48.3346V25.7733C9.96472 25.2804 10.364 24.8809 10.8566 24.8809C11.3491 24.8809 11.7484 25.2804 11.7484 25.7733V48.3346C11.7484 48.8275 11.3491 49.2271 10.8566 49.2271Z"
                    fill="#F1AF38"
                  />
                  <path
                    d="M6.87352 64.4634C6.64574 64.4634 6.46277 63.935 6.46277 63.2797V53.8156C6.46277 53.1622 6.64761 52.6338 6.87352 52.6338C7.1013 52.6338 7.28615 53.1622 7.28615 53.8156V63.2797C7.28615 63.9331 7.10317 64.4634 6.87352 64.4634Z"
                    fill="#F1AF38"
                  />
                  <path
                    d="M8.22795 64.5063C8.00017 64.5063 7.8172 63.9779 7.8172 63.3225V53.8585C7.8172 53.205 8.00204 52.6748 8.22795 52.6748C8.45573 52.6748 8.64058 53.2032 8.64058 53.8585V63.3225C8.63872 63.976 8.45573 64.5063 8.22795 64.5063Z"
                    fill="#F1AF38"
                  />
                  <path
                    d="M9.58079 64.5489C9.35301 64.5489 9.16821 64.0205 9.16821 63.3652V53.9029C9.16821 53.2495 9.35301 52.7192 9.58079 52.7192C9.80857 52.7192 9.99342 53.2476 9.99342 53.9029V63.3652C9.99342 64.0205 9.80857 64.5489 9.58079 64.5489Z"
                    fill="#F1AF38"
                  />
                  <path
                    d="M10.9352 64.5937C10.7074 64.5937 10.5226 64.0653 10.5226 63.41V53.9459C10.5226 53.2925 10.7074 52.7622 10.9352 52.7622C11.163 52.7622 11.346 53.2906 11.346 53.9459V63.41C11.346 64.0634 11.163 64.5937 10.9352 64.5937Z"
                    fill="#F1AF38"
                  />
                  <path
                    d="M12.2878 64.6367C12.06 64.6367 11.8752 64.1083 11.8752 63.4548V53.9908C11.8752 53.3374 12.06 52.8071 12.2878 52.8071C12.5156 52.8071 12.7004 53.3374 12.7004 53.9908V63.4548C12.7004 64.1083 12.5156 64.6367 12.2878 64.6367Z"
                    fill="#F1AF38"
                  />
                  <path
                    d="M13.6873 64.6802C13.4595 64.682 13.271 64.1556 13.2672 63.5021L13.1963 54.0381C13.1907 53.3846 13.3718 52.8525 13.5996 52.8506C13.8274 52.8487 14.0159 53.3753 14.0196 54.0287L14.0906 63.4909C14.0943 64.1462 13.9132 64.6783 13.6873 64.6802Z"
                    fill="#F1AF38"
                  />
                  <path
                    d="M6.3974 58.5926C6.3974 58.5926 4.38431 45.9863 10.8565 46.7051C17.3287 47.4258 14.0879 58.5926 14.0879 58.5926H6.3974Z"
                    fill="#F1AF38"
                  />
                  <path
                    d="M151.345 51.3745C151.345 55.0152 123.354 57.9671 88.827 57.9671C54.2999 57.9671 26.3085 55.0152 26.3085 51.3745C26.3085 47.7338 54.2999 44.782 88.827 44.782C123.354 44.782 151.345 47.7338 151.345 51.3745Z"
                    fill="#AAC6F9"
                  />
                  <path
                    d="M151.345 24.2981H26.3066V51.374H151.345V24.2981Z"
                    fill="#033049"
                  />
                  <path
                    d="M5.60083 26.1909L84.2895 48.5954L172.051 26.1909L84.1832 0L5.60083 26.1909Z"
                    fill="#AAC6F9"
                  />
                  <path
                    d="M75.3752 72.4139C75.3752 83.1513 66.6529 91.8798 55.9007 91.8798C45.171 91.8798 36.4487 83.1513 36.4487 72.4139C36.4487 61.6766 45.171 52.9258 55.9007 52.9258C66.6529 52.9258 75.3752 61.6766 75.3752 72.4139Z"
                    fill="#8ECAEC"
                  />
                  <path
                    d="M55.9101 91.8851C45.1766 91.8851 36.4432 83.1473 36.4432 72.4062C36.4432 61.6651 45.1766 52.9255 55.9101 52.9255C66.6436 52.9255 75.3771 61.6651 75.3771 72.4062C75.3771 83.1492 66.6436 91.8851 55.9101 91.8851ZM55.9101 57.3915C47.6356 57.3915 40.906 64.1278 40.906 72.4062C40.906 80.6866 47.6375 87.4191 55.9101 87.4191C64.1846 87.4191 70.9142 80.6847 70.9142 72.4062C70.9161 64.1278 64.1846 57.3915 55.9101 57.3915Z"
                    fill="#F1AF38"
                  />
                  <path
                    d="M61.3152 72.4029C61.3152 75.3865 58.8954 77.8099 55.914 77.8099C52.9288 77.8099 50.5127 75.3883 50.5127 72.4029C50.5127 69.4194 52.9288 66.9978 55.914 66.9978C56.4289 66.9978 56.9289 67.0706 57.401 67.2069C56.1248 67.4795 55.164 68.6166 55.164 69.9814C55.164 71.5478 56.4345 72.8155 57.9961 72.8155C59.5055 72.8155 60.7388 71.6374 60.8283 70.1513C61.138 70.8365 61.3152 71.5982 61.3152 72.4029Z"
                    fill="#033049"
                  />
                  <path
                    d="M101.852 72.4101C101.852 83.1474 110.574 91.8759 121.326 91.8759C132.056 91.8759 140.778 83.1474 140.778 72.4101C140.778 61.6727 132.056 52.9219 121.326 52.9219C110.574 52.9219 101.852 61.6727 101.852 72.4101Z"
                    fill="#8ECAEC"
                  />
                  <path
                    d="M101.852 72.4043C101.852 61.6632 110.585 52.9236 121.319 52.9236C132.052 52.9236 140.786 61.6632 140.786 72.4043C140.786 83.1454 132.052 91.8813 121.319 91.8813C110.585 91.8813 101.852 83.1454 101.852 72.4043ZM106.313 72.4043C106.313 80.6847 113.044 87.4172 121.317 87.4172C129.591 87.4172 136.321 80.6828 136.321 72.4043C136.321 64.124 129.589 57.3895 121.317 57.3895C113.044 57.3895 106.313 64.124 106.313 72.4043Z"
                    fill="#F1AF38"
                  />
                  <path
                    d="M115.914 72.3987C115.914 75.3823 118.333 77.8057 121.315 77.8057C124.3 77.8057 126.718 75.3841 126.718 72.3987C126.718 69.4133 124.302 66.9937 121.315 66.9937C120.8 66.9937 120.302 67.0665 119.83 67.2028C121.106 67.4753 122.067 68.6142 122.067 69.9772C122.067 71.5436 120.796 72.8113 119.235 72.8113C117.725 72.8113 116.492 71.6332 116.402 70.1471C116.089 70.8323 115.914 71.594 115.914 72.3987Z"
                    fill="#033049"
                  />
                  <path
                    d="M101.852 70.1738H75.3771V74.6379H101.852V70.1738Z"
                    fill="#F1AF38"
                  />
                  <path
                    d="M73.3583 95.8074L88.827 85.5723L104.294 95.8074H73.3583Z"
                    fill="#F1AF38"
                  />
                </svg>
              }
            >
              {t("knowledgeGap.cards.curationGap.description")}
            </GapCard>
          </div>
        </div>
      </div>
    </section>
  );
}
